<template>
  <div style="height:100%;">
    <base-table v-bind="$attrs" v-on="$listeners" :columns="columns">
	<template v-for="($scopedSlot,name) in $scopedSlots" v-slot:[name]='{row}'>
        <slot :name="name" :row='row'></slot>
      </template>
    </base-table>
  </div>
</template>

<script>
import BaseTable from "./BaseTable";
export default {
  components: { BaseTable },
  props: {
    column: {
      type: Array,
      required: true,
      desc: "表格配置",
    },
  },
  computed: {
    columns() {
      return this.column.map((crr) => {
        if (crr.template) {
          crr.field = crr.template;
          crr.slots = {
            default: crr.template,
          };
        }
        if (crr.prop) crr.field = crr.prop;
		crr.title = crr.label
		return crr
      });
    },
  },
  data: () => ({
    // 多选
    multipleSelection: [],
    // 分页
    tableloading: false,
    tableData: [],
    pageNum: 1,
    pageSize: 20,
    count: 0,
    tableConf: [
      { field: "bizType", title: "服务商", width: 90 },
      // { prop: 'providerName', label: '服务商', width: 90 },
      // { prop: 'bizType', label: '业务类型', width: 160 },
      // { template: 'providerQuoteName', label: '报价名', width: 260 },
      // { template: 'providerQuoteStatus', label: '状态', width: 100 },
      // { template: 'recentPickupMinutes', label: '渠道时效', width: 160 },
      // { template: 'lastUpdateTime', label: '更新时间', width: 160 },
      // { template: 'lastUpdateContent', label: '更新内容' },
    ],
  }),
  methods: {},
  mounted() {
    console.log(this.columns);
  },
};
</script>

<style></style>
